import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { setMapCursor } from '@openlayers/ol-utils';
import { MapOverlays } from '@openlayers/ol-overlays';
import { LogpointsLayer } from '@openlayers/logpoints/LogpointsLayer';
import Feature from 'ol/Feature';
import { DateUtils } from '@shared/utils/DateUtils';
import { ProjectCodesService } from '@shared/services/ProjectCodesService';
import { mapRootStore, mapWrapper } from '@pages/map/map';
import * as React from 'react';
import { LogpointInfo } from '@pages/map/actions/LogpointInfo';
import { LogpointsEditor2dMap } from '@pages/map/actions/LogpointsEditor2dMap';
import { WindowManager } from '@shared/ui-react/FloatingWindow';

export class LogpointDesktopMouseInteraction extends FeatureMouseInteraction<LogpointsLayer> {
    onClick = (feature: Feature, e, n, allFeatures): void => {
        if (allFeatures.length > 1) {
            const ul = $('<div class="images-cluster-list" style="width: 300px; max-height: 55vh; overflow-x: hidden">');
            const sortedLogpoints = allFeatures
                .map(f => f.get('data'))
                .sort((a: IImage, b: IImage) => {
                    return (b.timestamp || b.originalDate) - (a.timestamp || a.originalDate);
                });
            sortedLogpoints.map(data => {
                const html = `
<div class="images-cluster-list-item" data-id="${data.id}">
    ${this.getDialogHTML(data)}
    ${
        kuura.hasPrivilege('LOGPOINTS_PAGE')
            ? `<button class="right ik-button-small ik-button-secondary--subtle" style="position: absolute; right: 5px"><i class="iki iki-edit"></i></button>`
            : ''
    }
</div>
`;
                ul.append(html);
            });

            MapOverlays.showDialog(this.map, ul, e, n, feature);

            setTimeout(() => {
                $('.images-cluster-list-item').on('click', event => {
                    this.displayLogpointInfo(parseInt((event.currentTarget as HTMLDivElement).dataset.id), e, n);
                });

                $('.images-cluster-list-item button').on('click', e => {
                    e.stopPropagation();
                    this.handleEdit(parseInt((e.currentTarget.closest('.images-cluster-list-item') as HTMLDivElement).dataset.id));
                });
            }, 1);
        } else if (feature) {
            const data = feature.get('data');
            this.displayLogpointInfo(data.id, e, n);
        }
    };

    onMouseOver = _.throttle((feature: Feature, e, n) => {
        MapOverlays.hideTooltip(this.map);
        setMapCursor(this.map, 'pointer');
        const data = feature.get('data');
        MapOverlays.showTooltip(this.map, `<div class="popup no-break-text" style="padding: 10px">${this.getDialogHTML(data)}</div>`, e, n);
    }, 16);

    displayLogpointInfo = (id: number, e, n) => {
        WindowManager.open({
            group: 'logpoint-info',
            id: String(id),
            resize: null,
            allowMultiple: true,
            showCloseButton: true,
            body: React.createElement(LogpointInfo, {
                logpointId: id,
            }),
        });
    };

    handleEdit = (logpointId: number) => {
        const logpointFeature = mapWrapper.featureLayers.logpoints.getFeatureById(logpointId);
        if (logpointFeature) {
            const logpoints: ILogpoint[] = [mapWrapper.featureLayers.logpoints.getAjaxData(logpointFeature)];
            LogpointsEditor2dMap.open(logpoints, false, 'click', mapRootStore.treeData);
        }
    };

    getDialogHTML(point) {
        const content = [];
        content.push("<div class='json-pairs'>");

        if (point.code) {
            content.push('<div>');
            content.push(kuura.getMessage('tablet.code_js'));
            content.push(': ');
            content.push(ProjectCodesService.codeWithDescription(point.code));
            content.push('</div>');
        }

        if (point.number) {
            content.push('<div>');
            content.push(kuura.getMessage('tablet.number_js'));
            content.push(': ');
            content.push(point.number);
            content.push('</div>');
        }

        content.push(kuura.getMessage('general.upload_date'));
        content.push(': ');
        content.push(DateUtils.formatDateTime(point.timestamp));
        content.push('</div>');

        return content.join('');
    }
}
